module.exports = __webpack_public_path__ + "static/media/gains-logo-white.05eeda67.svg";